import { QueryClient } from '@tanstack/react-query';

/**
 * Global React Query client configuration
 * Aggressively optimized for performance with smart caching
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000, // 10 minutes - products rarely change
      gcTime: 60 * 60 * 1000, // 60 minutes cache retention (1 hour)
      refetchOnWindowFocus: false, // Don't refetch on tab focus
      refetchOnReconnect: false, // Don't refetch on reconnect
      refetchOnMount: false, // Use cached data always
      retry: 1, // Single retry for faster failure
      retryDelay: 500, // 500ms retry delay
      networkMode: 'offlineFirst', // Use cache first, then network
    },
    mutations: {
      retry: 1,
      retryDelay: 500,
    },
  },
});
